export default "/images/our_specialty_divider__first.png";